<template>
  <div>
    <v-row>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline"> Upload Supporting Documents </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container class="pt-10">
              <Uploader
                :multiple="true"
                @addedFiles="addedFiles"
                :supportingOnly="true"
                :doneUploading="doneUploading"
              />
              <v-row>
                <v-col
                  cols="12"
                  class="mb-n14"
                  style="margin-bottom: 70px"
                  v-if="upload_loader"
                >
                  <v-progress-linear
                    color="indigo"
                    loading
                    disabled
                    buffer-value="0"
                    indeterminate
                    stream
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pt-3 pb-3">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="uploadSupportingDocument()"
              :disabled="disableSave"
            >
              Upload and Save
            </v-btn>
            <v-btn text @click="close()" class="pr-5"> Cancel </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { fileSystemUrl } from "../../../config/config.json";
import Uploader from "../../documents/utils/Uploader.vue";
export default {
  name: "AddDocuments",
  props: {
    dialog: Boolean,
    document_id: Number,
  },
  components: {
    Uploader,
  },
  data() {
    return {
      disableSave: true,
      upload_loader: false,
      supporting_documents: [],
      uploaded_supporting_documents: [],
      doneUploading: false,
    };
  },
  methods: {
    ...mapActions([
      "createSupportingDocument",
      "attachSupportingDocuments"
    ]),
    close() {
      
      this.supporting_documents = []
      this.uploaded_supporting_documents = []
      this.$emit("closeDialog", false);
    },
    addedFiles(files) {
      this.supporting_documents = [];
      files.forEach((item) => {
        this.supporting_documents.push(item.file);
      });
      if (this.supporting_documents.length > 0) this.disableSave = false;
      else this.disableSave = true;
    },
    async uploadSupportingDocument() {
      this.upload_loader = false;
      let files = this.supporting_documents;
      if (files.length > 0) {
        this.disableSave = true;
        this.upload_loader = true;
        Promise.all(
          files.map(async (file) => {
            const formData = new FormData();
            formData.append("documentFile", file, file.name);
            const authToken = localStorage.getItem("access_token");
            const response = await axios.post(
              `${fileSystemUrl}/uploadFile`,
              formData,
              {
                headers: {
                  "x-drmms-token": authToken,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            this.uploaded_supporting_documents.push({
              file_type: response.data.file_type,
              filepath_url: response.data.filepath_url,
              date_uploaded: response.data.date_uploaded,
              user_uploaded: response.data.user_id,
            });
          })
        ).then(() => {
          this.disableSave = false;
          this.upload_loader = false;
          this.add();
        });
      }
    },

    async add() {
        await this.createSupportingDocument({
            document_id: this.document_id,
            uploaded_supporting_documents: this.uploaded_supporting_documents,
        }).then((res) => {
            this.doneUploading = true
            let documents = []
            res.forEach(document => {
                documents.push({document: document, isMainDocument: false})
            })
            this.attachSupportingDocuments({documents: documents, isUpdate: false}).then(() => {
                
                this.doneUploading = false
                this.$emit('appendData', documents)
                this.close()
            })
        })
    },
  },
  computed: {
      ...mapGetters([
      "getSupportingDocuments",
    ]),
  }
};
</script>
<style scoped>
</style>
